import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'

// Libs
import { fetchLiveInfo } from '@/api/fetchLiveInfo'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Types

interface LiveDataProps {
  productId?: any
  merchantId?: any
}

export const useLiveData = ({ productId = '0', merchantId = '0' }: LiveDataProps) => {
  const [isLive, setIsLive] = useState(false)
  const [isMerchantLive, setIsMerchantLive] = useState(false)
  const [roomId, setRoomId] = useState('')

  const { data: liveData, isFetched: isLiveDataFetched, isSuccess } = useQuery([QUERY_KEY.FETCH_LIVE_INFO], () => fetchLiveInfo(), {})

  // 檢查參數是否有效
  const isValidProductId = productId && productId !== '0' && productId !== ''
  const isValidMerchantId = merchantId && merchantId !== '0' && merchantId !== ''

  useEffect(() => {
    if (isSuccess && liveData) {
      const productLiveData = isValidProductId ? liveData?.productMap?.[productId] : null
      const merchantLiveData = isValidMerchantId ? liveData?.merchantMap?.[merchantId] : null

      setIsLive(!!productLiveData)
      setIsMerchantLive(!!merchantLiveData)

      // 重置 roomId
      setRoomId('')

      // TODO: 不確定如果productLiveData和merchantLiveData都有值要怎麼處理
      if (productLiveData?.roomId) {
        setRoomId(productLiveData.roomId)
      } else if (merchantLiveData?.roomId) {
        setRoomId(merchantLiveData.roomId)
      }
    } else {
      // 當 API 未成功或資料為空時，重置狀態
      setIsLive(false)
      setIsMerchantLive(false)
      setRoomId('')
    }
  }, [isSuccess, liveData, merchantId, productId, isValidMerchantId, isValidProductId])

  return {
    liveData: liveData || null,
    isLive,
    isMerchantLive,
    roomId,
    isSuccess,
    isLiveDataFetched,
    liveProductInfo: isValidProductId ? liveData?.productMap?.[productId] || null : null,
    liveMerchantInfo: isValidMerchantId ? liveData?.merchantMap?.[merchantId] || null : null,
  }
}
